const translations = {
  // ==================== COMMON / NAV ====================
  nav: {
    exams: { fr: 'Examens', en: 'Exams' },
    myResults: { fr: 'Mes résultats', en: 'My Results' },
    myExams: { fr: 'Mes examens', en: 'My Exams' },
    admin: { fr: 'Admin', en: 'Admin' },
    login: { fr: 'Connexion', en: 'Login' },
    register: { fr: "S'inscrire", en: 'Sign Up' },
    logout: { fr: 'Se déconnecter', en: 'Log Out' },
    privacy: { fr: 'Politique de confidentialité', en: 'Privacy Policy' },
    terms: { fr: "Conditions d'utilisation", en: 'Terms of Use' },
  },

  // ==================== HOME PAGE ====================
  home: {
    badge: { fr: 'Préparation aux certifications professionnelles', en: 'Professional Certification Preparation' },
    title: { fr: 'Préparez vos examens de', en: 'Prepare your' },
    titleHighlight: { fr: 'certification', en: 'certification exams' },
    subtitle: { fr: "Accédez à des milliers de questions d'entraînement pour réussir vos certifications IT, sécurité, cloud et plus encore.", en: 'Access thousands of practice questions to pass your IT, security, cloud certifications and more.' },
    ctaExplore: { fr: 'Explorer les examens', en: 'Explore Exams' },
    ctaRegister: { fr: 'Créer un compte gratuit', en: 'Create a Free Account' },
    whyTitle: { fr: 'Pourquoi examprep ?', en: 'Why examprep?' },
    feature1Title: { fr: 'Questions réalistes', en: 'Realistic Questions' },
    feature1Desc: { fr: 'Des questions calquées sur les vrais examens pour une préparation optimale.', en: 'Questions modeled on real exams for optimal preparation.' },
    feature2Title: { fr: 'Explications détaillées', en: 'Detailed Explanations' },
    feature2Desc: { fr: "Chaque question accompagnée d'une explication pour comprendre vos erreurs.", en: 'Each question comes with an explanation to understand your mistakes.' },
    feature3Title: { fr: 'Suivi de progression', en: 'Progress Tracking' },
    feature3Desc: { fr: 'Analysez vos résultats par domaine pour cibler vos révisions.', en: 'Analyze your results by domain to target your study.' },
    ctaFreeTitle: { fr: 'Commencez gratuitement', en: 'Start for Free' },
    ctaFreeDesc: { fr: 'Testez 10 questions gratuitement pour chaque examen. Sans engagement.', en: 'Try 10 questions for free on each exam. No commitment.' },
    ctaSeeExams: { fr: 'Voir les examens', en: 'See Exams' },
    ctaCreateAccount: { fr: 'Créer mon compte', en: 'Create My Account' },
    copyright: { fr: '© 2026 examprep. Tous droits réservés.', en: '© 2026 examprep. All rights reserved.' },
  },

  // ==================== LOGIN ====================
  login: {
    title: { fr: 'Connexion', en: 'Login' },
    subtitle: { fr: 'Connectez-vous pour accéder à vos examens', en: 'Log in to access your exams' },
    email: { fr: 'Email', en: 'Email' },
    emailPlaceholder: { fr: 'vous@exemple.com', en: 'you@example.com' },
    password: { fr: 'Mot de passe', en: 'Password' },
    submit: { fr: 'Se connecter', en: 'Log In' },
    submitting: { fr: 'Connexion...', en: 'Logging in...' },
    noAccount: { fr: 'Pas encore de compte ?', en: "Don't have an account?" },
    register: { fr: "S'inscrire", en: 'Sign Up' },
    success: { fr: 'Connexion réussie', en: 'Login successful' },
    error: { fr: 'Erreur de connexion', en: 'Login error' },
  },

  // ==================== REGISTER ====================
  register: {
    title: { fr: 'Créer un compte', en: 'Create an Account' },
    subtitle: { fr: 'Inscrivez-vous pour commencer votre préparation', en: 'Sign up to start your preparation' },
    name: { fr: 'Nom complet', en: 'Full Name' },
    namePlaceholder: { fr: 'Jean Dupont', en: 'John Doe' },
    email: { fr: 'Email', en: 'Email' },
    emailPlaceholder: { fr: 'vous@exemple.com', en: 'you@example.com' },
    password: { fr: 'Mot de passe', en: 'Password' },
    confirmPassword: { fr: 'Confirmer le mot de passe', en: 'Confirm Password' },
    consent: { fr: "J'accepte la", en: 'I accept the' },
    consentPrivacy: { fr: 'politique de confidentialité', en: 'privacy policy' },
    consentAnd: { fr: 'et les', en: 'and the' },
    consentTerms: { fr: "conditions d'utilisation", en: 'terms of use' },
    submit: { fr: 'Créer mon compte', en: 'Create My Account' },
    submitting: { fr: 'Création...', en: 'Creating...' },
    hasAccount: { fr: 'Déjà inscrit ?', en: 'Already registered?' },
    login: { fr: 'Se connecter', en: 'Log In' },
    success: { fr: 'Compte créé avec succès', en: 'Account created successfully' },
    error: { fr: "Erreur lors de l'inscription", en: 'Registration error' },
    passwordMismatch: { fr: 'Les mots de passe ne correspondent pas', en: 'Passwords do not match' },
    passwordTooShort: { fr: 'Le mot de passe doit contenir au moins 8 caractères', en: 'Password must be at least 8 characters' },
    consentRequired: { fr: 'Vous devez accepter la politique de confidentialité', en: 'You must accept the privacy policy' },
  },

  // ==================== EXAMS PAGE ====================
  exams: {
    title: { fr: 'Examens disponibles', en: 'Available Exams' },
    subtitle: { fr: 'Choisissez un examen pour commencer votre préparation', en: 'Choose an exam to start your preparation' },
    searchPlaceholder: { fr: 'Rechercher un examen...', en: 'Search for an exam...' },
    all: { fr: 'Tous', en: 'All' },
    noExams: { fr: 'Aucun examen trouvé', en: 'No exams found' },
    scoreRequired: { fr: 'Score requis', en: 'Required score' },
    minutes: { fr: 'min', en: 'min' },
    questions: { fr: 'questions', en: 'questions' },
  },

  // ==================== EXAM DETAIL ====================
  examDetail: {
    backToExams: { fr: 'Retour aux examens', en: 'Back to exams' },
    minutes: { fr: 'minutes', en: 'minutes' },
    questions: { fr: 'questions', en: 'questions' },
    requiredScore: { fr: 'score requis', en: 'required score' },
    inBank: { fr: 'dans la banque', en: 'in the bank' },
    startFull: { fr: "Démarrer l'examen complet", en: 'Start Full Exam' },
    freePreview: { fr: 'Aperçu gratuit (10 questions)', en: 'Free Preview (10 questions)' },
    buyAccess: { fr: "Acheter l'accès", en: 'Buy Access' },
    notEnoughQuestions: { fr: 'Pas assez de questions disponibles', en: 'Not enough questions available' },
    domainsTitle: { fr: 'Domaines couverts', en: 'Covered Domains' },
    fullAccessRequired: { fr: 'Accès complet requis', en: 'Full Access Required' },
    fullAccessDesc: { fr: "Pour accéder à l'examen complet avec toutes les questions et explications, vous devez acheter un accès.", en: 'To access the full exam with all questions and explanations, you must purchase access.' },
    thisExam: { fr: 'Cet examen', en: 'This exam' },
    allExams: { fr: 'Tous les examens', en: 'All exams' },
    days: { fr: 'jours', en: 'days' },
    loginRequired: { fr: 'Veuillez vous connecter pour commencer', en: 'Please log in to start' },
    noQuestions: { fr: 'Aucune question disponible pour cet examen', en: 'No questions available for this exam' },
    notFound: { fr: 'Examen non trouvé', en: 'Exam not found' },
    loadError: { fr: 'Erreur lors du chargement', en: 'Loading error' },
  },

  // ==================== PAYMENT ====================
  payment: {
    title: { fr: 'Acheter un accès', en: 'Purchase Access' },
    back: { fr: 'Retour', en: 'Back' },
    accessType: { fr: "Type d'accès", en: 'Access Type' },
    accessDuration: { fr: 'Accès pendant', en: 'Access for' },
    accessDays: { fr: 'jours', en: 'days' },
    singleLifetime: { fr: 'Accès à vie', en: 'Lifetime Access' },
    singleLifetimeDesc: { fr: 'Accès permanent à cet examen, sans limite de durée', en: 'Permanent access to this exam, no time limit' },
    allExamsAccess: { fr: 'Accès à tous les examens', en: 'Access to all exams' },
    allExamsDesc: { fr: 'Accès illimité à tous les examens pendant', en: 'Unlimited access to all exams for' },
    allExamsLifetime: { fr: 'Accès complet à vie', en: 'Lifetime Full Access' },
    allExamsLifetimeDesc: { fr: 'Accès permanent à tous les examens, sans limite de durée', en: 'Permanent access to all exams, no time limit' },
    lifetime: { fr: 'À vie', en: 'Lifetime' },
    couponTitle: { fr: 'Code promo', en: 'Promo Code' },
    couponPlaceholder: { fr: 'Entrez votre code', en: 'Enter your code' },
    couponApply: { fr: 'Appliquer', en: 'Apply' },
    couponValid: { fr: 'de réduction appliquée', en: 'discount applied' },
    couponInvalid: { fr: 'Coupon invalide', en: 'Invalid coupon' },
    summary: { fr: 'Récapitulatif', en: 'Summary' },
    subtotal: { fr: 'Sous-total', en: 'Subtotal' },
    discount: { fr: 'Réduction', en: 'Discount' },
    total: { fr: 'Total', en: 'Total' },
    paymentTitle: { fr: 'Paiement', en: 'Payment' },
    activateFree: { fr: "Activer l'accès gratuit", en: 'Activate Free Access' },
    activating: { fr: 'Activation...', en: 'Activating...' },
    paypalNotConfigured: { fr: "Le paiement PayPal n'est pas configuré.", en: 'PayPal payment is not configured.' },
    contactAdmin: { fr: "Veuillez contacter l'administrateur.", en: 'Please contact the administrator.' },
    successTitle: { fr: 'Paiement réussi !', en: 'Payment Successful!' },
    successDesc: { fr: 'Votre accès a été activé. Vous pouvez maintenant commencer vos examens.', en: 'Your access has been activated. You can now start your exams.' },
    seeExams: { fr: 'Voir les examens', en: 'See Exams' },
    orderError: { fr: 'Erreur lors de la création de la commande', en: 'Error creating order' },
    captureError: { fr: 'Erreur lors de la capture du paiement', en: 'Error capturing payment' },
    paypalError: { fr: 'Erreur PayPal. Veuillez réessayer.', en: 'PayPal error. Please try again.' },
    cancelled: { fr: 'Paiement annulé', en: 'Payment cancelled' },
    freeActivated: { fr: 'Accès gratuit activé !', en: 'Free access activated!' },
    paymentSuccess: { fr: 'Paiement réussi ! Accès activé.', en: 'Payment successful! Access activated.' },
  },

  // ==================== PROFILE ====================
  profile: {
    title: { fr: 'Mon profil', en: 'My Profile' },
    personalInfo: { fr: 'Informations personnelles', en: 'Personal Information' },
    administrator: { fr: 'Administrateur', en: 'Administrator' },
    registeredOn: { fr: 'Inscrit le', en: 'Registered on' },
    subscription: { fr: 'Abonnement', en: 'Subscription' },
    allAccess: { fr: 'Accès à tous les examens', en: 'Access to all exams' },
    singleAccess: { fr: 'Accès à un examen', en: 'Access to one exam' },
    expiresOn: { fr: 'Expire le', en: 'Expires on' },
    expired: { fr: 'Votre abonnement a expiré', en: 'Your subscription has expired' },
    noSubscription: { fr: 'Aucun abonnement actif', en: 'No active subscription' },
    buyAccess: { fr: 'Acheter un accès', en: 'Buy Access' },
    myExamsTitle: { fr: 'Mes examens', en: 'My Exams' },
    active: { fr: 'Actif', en: 'Active' },
    expiredBadge: { fr: 'Expiré', en: 'Expired' },
    inactive: { fr: 'Inactif', en: 'Inactive' },
    attempts: { fr: 'tentative', en: 'attempt' },
    attemptsPlural: { fr: 'tentatives', en: 'attempts' },
    lastScore: { fr: 'Dernier score', en: 'Last score' },
    passed: { fr: 'Réussi', en: 'Passed' },
    failed: { fr: 'Échoué', en: 'Failed' },
    takeExam: { fr: "Passer l'examen", en: 'Take Exam' },
    renew: { fr: 'Renouveler', en: 'Renew' },
    noExams: { fr: "Vous n'avez acheté aucun examen", en: "You haven't purchased any exams" },
    browseExams: { fr: 'Parcourir les examens', en: 'Browse Exams' },
    // GDPR
    dataTitle: { fr: 'Mes données personnelles', en: 'My Personal Data' },
    exportData: { fr: 'Exporter mes données', en: 'Export My Data' },
    exportDataDesc: { fr: 'Télécharger toutes vos données au format JSON', en: 'Download all your data in JSON format' },
    exporting: { fr: 'Export en cours...', en: 'Exporting...' },
    deleteAccount: { fr: 'Supprimer mon compte', en: 'Delete My Account' },
    deleteAccountDesc: { fr: 'Cette action est irréversible. Toutes vos données seront supprimées.', en: 'This action is irreversible. All your data will be deleted.' },
    deleteConfirm: { fr: 'Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible.', en: 'Are you sure you want to delete your account? This action is irreversible.' },
    deleteSuccess: { fr: 'Compte supprimé avec succès', en: 'Account deleted successfully' },
    deleteError: { fr: 'Erreur lors de la suppression', en: 'Error during deletion' },
    // Orders History
    ordersTitle: { fr: 'Historique des commandes', en: 'Order History' },
    noOrders: { fr: 'Aucune commande', en: 'No orders' },
    orderCompleted: { fr: 'Payé', en: 'Paid' },
    orderPending: { fr: 'En attente', en: 'Pending' },
  },

  // ==================== RESULTS ====================
  results: {
    title: { fr: 'Mes résultats', en: 'My Results' },
    noResults: { fr: "Vous n'avez pas encore de résultats", en: "You don't have any results yet" },
    startExam: { fr: 'Passer un examen', en: 'Take an exam' },
    score: { fr: 'Score', en: 'Score' },
    passed: { fr: 'Réussi', en: 'Passed' },
    failed: { fr: 'Échoué', en: 'Failed' },
    date: { fr: 'Date', en: 'Date' },
    details: { fr: 'Détails', en: 'Details' },
  },

  // ==================== COOKIE CONSENT ====================
  cookie: {
    title: { fr: 'Cookies & Confidentialité', en: 'Cookies & Privacy' },
    message: { fr: "Ce site utilise des cookies essentiels pour son fonctionnement. En continuant à utiliser ce site, vous acceptez notre", en: 'This site uses essential cookies for its operation. By continuing to use this site, you accept our' },
    privacyLink: { fr: 'politique de confidentialité', en: 'privacy policy' },
    accept: { fr: 'Accepter', en: 'Accept' },
    decline: { fr: 'Refuser', en: 'Decline' },
  },

  // ==================== PRIVACY POLICY ====================
  privacy: {
    title: { fr: 'Politique de confidentialité', en: 'Privacy Policy' },
    lastUpdate: { fr: 'Dernière mise à jour', en: 'Last updated' },
  },

  // ==================== TERMS ====================
  terms: {
    title: { fr: "Conditions d'utilisation", en: 'Terms of Use' },
    lastUpdate: { fr: 'Dernière mise à jour', en: 'Last updated' },
  },
};

export default translations;
